<template>
  <div class="sm-category-found">
    <div class="sm-wrapper">
      <div class="sm-brace-category">
        <h1 v-if="!this.selected_category > 0" class="sm-title">Найдено в категориях</h1>
        <h1 v-else class="sm-title">{{ this.selected_category_name }}</h1>
      </div>

      <ul v-if="!this.selected_category > 0" class="sm-category-found-list">
        <li v-if="item.value > 0" v-for="item in categories" class="sm-category-found-item" :key="item.id">
          <button class="sm-category-found-item__button" @click.stop="onSelectCategory(item.id)">
            <img class="sm-category-found-item__image" :src="getPicture(item.pictureUrl, item.id)">
            <div class="sm-category-found-item__meta"><span class="sm-category-found-item__name">{{ item.name }}</span>
              <span class="sm-category-found-item__value">{{ item.value }} товаров</span></div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: "found-in-categories",
  computed: {
    ...mapGetters("search", ["selected_category", "selected_category_name", "categoryFacets", "products"]),
    categories: function () {
      return this.categoryFacets;
    },
  },
  methods: {
    ...mapActions("search", ["selectCategory", "addFilter", "doSearch"]),
      onSelectCategory: function (category_id) {
      this.selectCategory(category_id);

      this.addFilter({category: category_id})
      this.doSearch().then(() => {}).catch(err => { console.log(err.response.statusText) })
    },
    getPicture: function (img, category_id) {
      if(img !== null) {
        return img;
      }

      // get image from first product
      for(let idx in this.products) {
        let cat = this.products[idx].categories.filter(function (item) {
          return item.id === category_id;
        });

        if(cat.length) {
          return this.products[idx].image_url;
        }
      }
      return null;
    }
  }
}
</script>